module.exports = __webpack_public_path__ + "img/img-area-juridico-banner.83ad2d07.png";